<template>
  <div v-if="isComponentVisible">
    <v-menu v-model="menuShown" bottom left offset-y content-class="tech-support-menu" min-width="250px">

      <template #activator="{ on }">
        <v-btn v-on="on" icon small>
          <v-icon small>fas fa-headphones</v-icon>
        </v-btn>
      </template>

      <app-tech-support-contacts class="text-body-2"></app-tech-support-contacts>

    </v-menu>
  </div>
</template>

<script>
import { globalSettingsHelper } from '@/helpers/settings-helper';
import AppTechSupportContacts from '@/components/Main/AppTechSupportContacts.vue';
export default {
  name: 'AppHeaderTechSupportBtn',
  components: { AppTechSupportContacts },
  data() {
    return {
      menuShown: false
    };
  },
  computed: {
    isTelegramVisible() { return !!globalSettingsHelper.managingCompanyInfo.telegram; },
    isViberVisible() { return !!globalSettingsHelper.managingCompanyInfo.viber; },
    isSocialMediaVisible() { return this.isTelegramVisible || this.isViberVisible; },
    isEmailVisible() { return !!globalSettingsHelper.managingCompanyInfo.emailSupport; },
    isPhoneVisible() { return !!globalSettingsHelper.managingCompanyInfo.phoneSupport; },
    isComponentVisible() { return this.isSocialMediaVisible || this.isEmailVisible || this.isPhoneVisible; }
  }
};
</script>

<style lang="scss">
@import '@/styles/common.scss';

.tech-support-menu.v-menu__content {
  @extend .menu-with-top-edging;

  &::before {
    right: 6px;
  }

  padding: 8px 16px 16px 16px;
}
</style>
